export const EMAIL_SCENARIOS = [
  'first_contact',
  'follow_up',
  'proposal_reminder',
  'onboarding',
  're_engagement',
];

export const EMAIL_TONES = [
  'professional',
  'friendly',
  'direct',
  'warm',
];

export const EMAIL_LANGUAGES = [
  'it',
  'en',
];
